package dev.alimmz.portfolio.presentation.screen

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import dev.alimmz.portfolio.domain.model.Project

/** Graphic project identities, deliberately distinct from product screenshots. */
@Composable
fun ProjectArtwork(project: Project, modifier: Modifier = Modifier) {
    val flight = project.id == "1"
    val accent = if (flight) Color(0xFFB7F377) else Color(0xFFFFBC9C)
    val background = if (flight) Color(0xFF183C30) else Color(0xFF442D4E)
    Box(modifier.background(Brush.linearGradient(listOf(background, Color(0xFF101713))))) {
        Canvas(Modifier.matchParentSize()) {
            val center = Offset(size.width * 0.68f, size.height * 0.48f)
            repeat(6) { i ->
                drawCircle(accent.copy(alpha = .18f), size.minDimension * (.18f + i * .13f), center, style = Stroke(1.dp.toPx()))
            }
            if (flight) {
                drawLine(accent, Offset(size.width * .12f, size.height * .75f), Offset(size.width * .88f, size.height * .2f), 2.dp.toPx())
                drawCircle(accent, 5.dp.toPx(), Offset(size.width * .88f, size.height * .2f))
            } else {
                repeat(4) { i ->
                    drawRoundRect(accent.copy(alpha = .10f + i * .04f), Offset(size.width * .38f + i * 22.dp.toPx(), size.height * .15f + i * 12.dp.toPx()), androidx.compose.ui.geometry.Size(90.dp.toPx(), 160.dp.toPx()), androidx.compose.ui.geometry.CornerRadius(12.dp.toPx()))
                }
            }
        }
        Column(Modifier.align(Alignment.BottomStart).padding(28.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Text(if (flight) "01 / EXPLORE THE WORLD" else "02 / FIND YOUR NEXT STORY", color = accent, fontSize = 11.sp, letterSpacing = 2.sp)
            Text(project.title, color = Color.White, fontSize = 38.sp, fontWeight = FontWeight.Black)
            Text(if (flight) "FLIGHT & TRAVEL" else "MOVIES · MULTIPLATFORM", color = accent, fontSize = 12.sp, letterSpacing = 3.sp)
        }
    }
}

@Composable
fun EngineeringSnapshot(gutter: androidx.compose.ui.unit.Dp, wide: Boolean) {
    val facts = listOf("5+" to "YEARS BUILDING", "20+" to "FEATURE MODULES", "5K" to "DAILY B2B USERS")
    Row(Modifier.fillMaxWidth().padding(horizontal = gutter, vertical = 24.dp), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
        facts.forEach { (number, label) ->
            androidx.compose.material3.Surface(
                modifier = Modifier.weight(1f),
                shape = androidx.compose.foundation.shape.RoundedCornerShape(20.dp),
                color = androidx.compose.material3.MaterialTheme.colorScheme.surface
            ) {
                Column(Modifier.padding(if (wide) 28.dp else 12.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    Text(number, style = androidx.compose.material3.MaterialTheme.typography.headlineLarge, fontWeight = FontWeight.Black)
                    Text(label, fontSize = if (wide) 11.sp else 9.sp, letterSpacing = 1.sp, color = androidx.compose.material3.MaterialTheme.colorScheme.onSurfaceVariant)
                }
            }
        }
    }
}
